import { useState } from 'react';

export const useSmartCardElementsRenderState = () => {
	// smart card elements render states
	const [isAvatarAvailable, setIsAvatarAvailable] = useState<boolean>();
	const [isOwnerNameAvailable, setIsOwnerNameAvailable] = useState<boolean>();
	const [isModifiedOnAvailable, setIsModifiedOnAvailable] = useState<boolean>();
	const [isCommentCountAvailable, setIsCommentCountAvailable] = useState<boolean>();
	const [isReactCountAvailable, setIsReactCountAvailable] = useState<boolean>();

	const isMetadataAvailable = [
		isAvatarAvailable,
		isOwnerNameAvailable,
		isModifiedOnAvailable,
	].every((v) => v === undefined)
		? undefined
		: isAvatarAvailable || isOwnerNameAvailable || isModifiedOnAvailable;
	const isSocialsAvailable = [isReactCountAvailable, isCommentCountAvailable].every(
		(v) => v === undefined,
	)
		? undefined
		: isReactCountAvailable || isCommentCountAvailable;

	return {
		setIsAvatarAvailable,
		setIsOwnerNameAvailable,
		setIsModifiedOnAvailable,
		setIsReactCountAvailable,
		setIsCommentCountAvailable,
		isMetadataAvailable,
		isSocialsAvailable,
	};
};
